import type { PdfiumApi, PdfiumTypeMap } from "@pdfking/renderer-wasm-pdfium"

type PointerDoc = PdfiumTypeMap["FPDF_DOCUMENT"]

export const CopyPage = async (
  { safeCall, writeString }: PdfiumApi,
  source_doc_pointer: PointerDoc,
  dest_doc_pointer: PointerDoc,
  insert_at: number
): Promise<void> => {
  const { pointer: range, free } = writeString("")

  await safeCall(
    "FPDF_ImportPages",
    dest_doc_pointer,
    source_doc_pointer,
    range,
    insert_at - 1
  )

  free()
}
